import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const voidVolume = {
    jpath: ['spectra', 'voidVolume'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default voidVolume;
//# sourceMappingURL=voidVolume.js.map